import moment from 'moment';

// eslint-disable-next-line camelcase
export function isFiltersProvided({ properties, region, dateFrom, dateTo }) {
  return !!properties && !!region && !!dateFrom && !!dateTo;
}

export function mapSelectedFilters(selectedFilters) {
  return {
    dateFrom: moment(selectedFilters?.start)?.format('YYYY-MM-DD'),
    dateTo: moment(selectedFilters?.end)?.format('YYYY-MM-DD'),
    benchmarks: selectedFilters?.benchmark_websites.join(';'),
    properties: selectedFilters?.websites.join(';'),
    region: selectedFilters?.regions.join(';'),
  };
}
